import type { AppConfig } from '../types/app-config.types';
import {
	readRawConfigBoolean,
	readRawConfigString
} from './read-raw-config-value.util';

export function mapRawConfigToAppConfig(
	config: Record<string, unknown>
): AppConfig {
	return {
		shared: {
			apiHost: readRawConfigString(config, 'VITE_API_HOST'),
			chatApi: readRawConfigString(config, 'VITE_CHAT_API'),
			cmsApiUrl: readRawConfigString(config, 'VITE_CMS_API_URL'),
			partnerIdn: readRawConfigString(config, 'VITE_PARTNER_IDN'),
			webCallConnectorIdn: readRawConfigString(
				config,
				'VITE_WEB_CALL_CONNECTOR_IDN'
			)
		},
		portal: {
			analyticsHost: readRawConfigString(config, 'VITE_ANALYTICS_HOST'),
			analyticsKey: readRawConfigString(config, 'VITE_ANALYTICS_KEY'),
			appEnv: readRawConfigString(config, 'VITE_APP_ENV'),
			auth0ClientId: readRawConfigString(config, 'VITE_AUTH0_CLIENT_ID'),
			auth0Domain: readRawConfigString(config, 'VITE_AUTH0_DOMAIN'),
			auth0Tenant: readRawConfigString(config, 'VITE_AUTH0_TENANT'),
			authCallbackUrl: readRawConfigString(config, 'VITE_AUTH_CALLBACK_URL'),
			buildMode: readRawConfigString(config, 'VITE_BUILD_MODE'),
			builderUrl: readRawConfigString(config, 'VITE_BUILDER_URL'),
			isPartnerFlowEnabled: readRawConfigBoolean(
				config,
				'VITE_IS_PARTNER_FLOW_ENABLED'
			),
			partnerSignupHubSpotWebhookUrl: readRawConfigString(
				config,
				'VITE_PARTNER_SIGNUP_HUBSPOT_WEBHOOK_URL'
			),
			phoneCallConnectorIdn: readRawConfigString(
				config,
				'VITE_PHONE_CALL_CONNECTOR_IDN'
			),
			calComCallLink: readRawConfigString(config, 'VITE_CAL_COM_CALL_LINK'),
			creatorRemoteUrl: readRawConfigString(config, 'VITE_CREATOR_REMOTE_URL'),
			creatorUrl: readRawConfigString(config, 'VITE_CREATOR_URL'),
			customLoginUrl: readRawConfigString(config, 'VITE_CUSTOM_LOGIN_URL'),
			flowBuilderRemoteUrl: readRawConfigString(
				config,
				'VITE_FLOW_BUILDER_REMOTE_URL'
			),
			intercomAppId: readRawConfigString(config, 'VITE_INTERCOM_APP_ID'),
			ionosPortalUrl: readRawConfigString(config, 'VITE_IONOS_PORTAL_URL'),
			ionosProvisioningUrl: readRawConfigString(
				config,
				'VITE_IONOS_PROVISIONING_URL'
			),
			isWebRtcFlowEnabled: readRawConfigBoolean(
				config,
				'VITE_IS_WEBRTC_FLOW_ENABLED'
			),
			marketingMaterialsLink: readRawConfigString(
				config,
				'VITE_MARKETING_MATERIALS_LINK'
			),
			partnerGtmId: readRawConfigString(config, 'VITE_PARTNER_GTM_ID'),
			portalClientSecret: readRawConfigString(
				config,
				'VITE_PORTAL_CLIENT_SECRET'
			),
			portalSecret: readRawConfigString(config, 'VITE_PORTAL_SECRET'),
			scheduleRoundRobinLink: readRawConfigString(
				config,
				'VITE_SCHEDULE_ROUND_ROBIN_LINK'
			),
			sentryDsn: readRawConfigString(config, 'VITE_SENTRY_DSN'),
			stripePublishableKey: readRawConfigString(
				config,
				'VITE_STRIPE_PUBLIC_KEY'
			),
			vibeBuilderRemoteUrl: readRawConfigString(
				config,
				'VITE_VIBE_BUILDER_REMOTE_URL'
			),
			webRtcBucketUrl: readRawConfigString(config, 'VITE_WEBRTC_BUCKET_URL'),
			wlPortalUrl: readRawConfigString(config, 'VITE_WL_PORTAL_URL')
		},
		creator: {
			basePath: readRawConfigString(config, 'VITE_BASE_PATH'),
			buildMode: readRawConfigString(config, 'VITE_BUILD_MODE'),
			creatorClientSecret:
				readRawConfigString(config, 'VITE_CREATOR_CLIENT_SECRET') ??
				readRawConfigString(config, 'VITE_PARTNER_CLIENT_SECRET'),
			e2e: readRawConfigBoolean(config, 'VITE_E2E'),
			googleApiKey: readRawConfigString(config, 'VITE_GOOGLE_API_KEY'),
			isWebRtcFlowEnabled: readRawConfigBoolean(
				config,
				'VITE_IS_WEBRTC_FLOW_ENABLED'
			),
			partnerCustomerIdn: readRawConfigString(
				config,
				'VITE_PARTNER_CUSTOMER_IDN'
			),
			partnerGtmId: readRawConfigString(config, 'VITE_PARTNER_GTM_ID'),
			partnerIndustry: readRawConfigString(config, 'VITE_PARTNER_INDUSTRY'),
			webRtcBucketUrl: readRawConfigString(config, 'VITE_WEBRTC_BUCKET_URL'),
			wlPortalUrl: readRawConfigString(config, 'VITE_WL_PORTAL_URL')
		},
		vibeBuilder: {
			basePath: readRawConfigString(config, 'VITE_BASE_PATH'),
			buildMode: readRawConfigString(config, 'VITE_BUILD_MODE'),
			e2eRealtimeMockEnabled: readRawConfigBoolean(
				config,
				'VITE_E2E_REALTIME_MOCK'
			)
		}
	};
}
